import React from "react";
import { withRouter } from "react-router-dom";

import "./styles.scss";

class Step2 extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        window.scrollTo(0,0);
    }

    renderSection1() {
        return (
            <div className="Section1Wrapper">
                <h1>Delegate to TBD Pool</h1>
                <p>
                    Once your ADA is in your wallet, you are ready to delegate your stake to a Cardano stake pool and earn stake rewards. Your funds will always stay in your wallet
                    while you are delegated to a stake pool. Your ADA is not ‘locked’ while you are delegated and you can send and receive ADA without effecting the rewards you
                    have already earned. Find more details about when your stake will become active below in the section ‘Delegation Cycle’.
                </p>
            </div>
        );
    }

    renderSection2() {
        return (
            <div className="Section2Wrapper">
                <h1>When do I get my first rewards?</h1>
                <p>
                    When you first start delegating to a Cardano stake pool, it will take some time until your stake becomes active and you receive your first staking rewards. The
                    diagram below shows the Cardano Delegation Cycle. The delegation and rewards system is separated into epochs. Each epoch is 5 days long. This means rewards are
                    automatically paid out every 5 days.
                </p>
                <p>
                    Let’s assume you have started delegating to a stake pool in Epoch 0. There is a snapshot at the end of Epoch 0, which determines the amount of ADA you have in
                    your wallet at that point in time. That amount of stake becomes active in Epoch 2. The rewards you have earned in Epoch 2 are calculated in Epoch 3, and the
                    rewards for Epoch 2 are paid out in Epoch 4. Since one epoch is 5 days long, it takes 15-20 days until you receive your first rewards (depending when in Epoch 0
                    you started delegating). From then on, as long as your wallet is delegated to a stake pool, you will receive rewards every 5 days.
                </p>
                <p>
                    Redelegating to a different stake pool will not make you lose any rewards. If you change delegation you will still be paid rewards from the previous stake pool
                    for another 3 epochs until the rewards from the new stake pool start getting paid out.
                </p>
            </div>
        );
    }

    renderSection3() {
        return (
            <div className="Section3Wrapper">
                <h1>What return can I expect on my stake?</h1>
                <p>
                    The Cardano protocol automatically calculates and pays out rewards to delegators every 5 days. The return you can expect is around 5% annually. The long term
                    rewards are the same for small, medium or large stake pools, as long as the stake pool produces blocks regularly.
                </p>
                <p>
                    There is a luck factor which determines how many blocks a stake pool gets allocated each epoch. This luck factor can vary much more for smaller pools compared
                    to large stake pools. This means small stake pools can make a lot more blocks than estimated in one epoch, and then fewer blocks in another epoch. However, the
                    overall long term rewards are the same compared to a large stake pool.
                </p>
            </div>
        );
    }

    render() {
        return (
            <div className="Step2MainWrapper">
                {this.renderSection1()}
                {this.renderSection2()}
                {this.renderSection3()}
            </div>
        );
    }
}

export default withRouter(Step2);
